import React from 'react';
import { motion } from 'framer-motion';
import { CornerFlourish } from './Ornaments';

const valueItems = [
  "Champagne Welcome",
  "Curated Bites",
  "Coffee Tastings",
  "Desserts",
  "Raffles",
  "Trusted Vendors",
  "Venue Tours"
];

const dotColors = ["bg-floral-marigold", "bg-floral-coral", "bg-floral-plum", "bg-floral-olive"];

export default function Rsvp() {
  const formUrl = "https://form.fillout.com/t/eHqPRFbwhLus";

  return (
    <section id="rsvp" className="bg-ivory px-4 py-16 md:py-32 relative overflow-hidden">
      <div className="absolute bottom-0 right-0 w-1/2 h-1/2 bg-floral-coral/5 blur-[120px] rounded-full pointer-events-none"></div>
      
      <div className="max-w-4xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="flex flex-col items-center mb-16 md:mb-24"
        >
          <h3 className="font-serif text-[10px] md:text-sm text-burgundy uppercase tracking-[0.4em] mb-8 text-center px-4">
            What Makes the Afternoon Special
          </h3>
          <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-3 md:gap-x-6 md:gap-y-4 max-w-3xl px-6">
            {valueItems.map((item, idx) => (
              <React.Fragment key={item}>
                <span className="font-sans text-[9px] md:text-[11px] uppercase tracking-[0.3em] text-burgundy font-medium">
                  {item}
                </span>
                {idx < valueItems.length - 1 && (
                  <div className={`w-1 h-1 md:w-1.5 md:h-1.5 rounded-full ${dotColors[idx % dotColors.length]} opacity-60`}></div>
                )}
              </React.Fragment>
            ))}
          </div>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-8 md:mb-12"
        >
          <h2 className="font-serif text-4xl md:text-7xl text-burgundy mb-6 leading-tight">
            Reserve Your Invitation
          </h2>
          <p className="font-sans font-light text-sm md:text-xl text-charcoal/80 max-w-3xl mx-auto leading-relaxed mb-10 px-6 text-balance">
            Join us Sunday, August 23, from 11:00 AM to 3:00 PM for an afternoon of estate tours, curated tastings, trusted wedding partners, inspiration, and thoughtful wedding experiences.
          </p>
          <div className="space-y-4 mb-4">
            <p className="font-serif italic text-base md:text-2xl text-burgundy/80 max-w-2xl mx-auto px-6">
              “No pressure. No overwhelming expo energy. Just a beautiful afternoon to explore, taste, meet, and imagine.”
            </p>
            <p className="font-sans text-[10px] md:text-xs text-estate-gold tracking-widest uppercase">
              RSVP takes less than two minutes.
            </p>
          </div>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, scale: 0.99 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="bg-ivory border-[0.5px] border-estate-gold/40 p-0.5 md:p-8 relative invitation-shadow overflow-hidden"
        >
          <CornerFlourish className="absolute top-3 left-3 w-6 h-6 md:w-8 md:h-8 text-estate-gold/30 z-20" accentColor="#D9795F" />
          <CornerFlourish className="absolute top-3 right-3 w-6 h-6 md:w-8 md:h-8 text-estate-gold/30 rotate-90 z-20" accentColor="#D99A2B" />
          <CornerFlourish className="absolute bottom-3 left-3 w-6 h-6 md:w-8 md:h-8 text-estate-gold/30 -rotate-90 z-20" accentColor="#7A2E4D" />
          <CornerFlourish className="absolute bottom-3 right-3 w-6 h-6 md:w-8 md:h-8 text-estate-gold/30 rotate-180 z-20" accentColor="#6E7451" />

          <div className="relative z-10 w-full flex flex-col items-center bg-ivory rounded-sm">
            <div className="w-full max-w-[760px] relative overflow-hidden">
              <iframe 
                src={formUrl} 
                width="100%" 
                title="RSVP Form"
                scrolling="no"
                className="w-full h-[1280px] sm:h-[1250px] md:h-[1180px] rounded-sm transition-all duration-300"
                style={{ border: 'none', overflow: 'hidden' }}
              >
                Loading...
              </iframe>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}